import Axios from 'axios';

const axios = Axios.create({
  timeout: 30000
});

export const setBaseUrl = (url: string) => {
  axios.defaults.baseURL = url;
};

export const setTenantId = (id: string) => {
  axios.defaults.headers["TenantId"] = id;
};

export default axios;
